export default __webpack_public_path__ + "static/media/create.8cd0fd6c.svg";